const countrydata = [
    "nigeria", "usa", "india", "ghana", "togo", "ado"
]

export default countrydata